import Promise from 'bluebird';
// import store from '../../store';
// import { OVERVIEW_PANEL_GET_CURRENT, OVERVIEW_PANEL_IS_VISIBLE } from '../../store/modules/overview-panel/types';

import worldMap from '../core/map';
import ColorBrewer from '../core/tools/colorbrewer';
import ColorFlatUI from '../core/tools/colorflatui';
import environment from '../environment';
import Leaflet from './Leaflet';
import {tryOrReturn} from "../../utils";

const LayerControls = (name) => require('../controls').get(name);
const LayerInfo = (name) => require('../info').get(name);
const get = (name, currentMap = worldMap.getCurrent()) => {
    return require('./index').default.get(name, currentMap);
};

const name = 'Voronoi';

class VoronoiLayer {
    constructor (currentMap) {
        // const mapId = currentMap._id;

        const onClick = (feature, layer) => {
            try {
                const status = LayerInfo(name).check(feature.properties.IdAgrupamento) ? 'uncheck' : 'check';
                $(`#Voronoi-selection-${feature.properties.IdAgrupamento}`).iCheck(status);
            } catch (err) {
                console.log(err);
            }
        };

        const onSuccess = (featureCollection) => {
            return new Promise((resolve, reject) => {
                const typeId =
                    tryOrReturn(() => Number(LayerControls(name).getTypeValue(true)), environment.get('TYPE.DYNAMIC'));

                if (typeId === environment.get('TYPE.DYNAMIC')) {
                    resolve(featureCollection);
                }

                const themeId =
                    tryOrReturn(() => Number(LayerControls(name).getThemeValue(currentMap._id)), 0);

                if (themeId > 0) {
                    LayerControls(name).colorize(featureCollection, get(name, currentMap)).then((fc) => {
                        resolve(fc);
                    });
                } else {
                    resolve(featureCollection);
                }
            });
        };

        const onComplete = (features) => {
            const typeId = (() => {
                try {
                    return Number(LayerControls(name).getTypeValue(true));
                } catch (error) {
                    return environment.get('TYPE.DYNAMIC');
                }
            })();

            LayerControls(name).show({
                show: false,
                refresh: true,
                empty: typeId === environment.get('TYPE.DYNAMIC')
            });

            // if (store.getters[OVERVIEW_PANEL_GET_CURRENT] === name && store.getters[OVERVIEW_PANEL_IS_VISIBLE] && LayerControls(name).getControls(mapId).button.overview.enable) {
            //     LayerControls(name).toggleOverview();
            // }
        };

        const onMouseover = feature => LayerInfo(name).highlight(feature);

        const onMouseout = feature => LayerInfo(name).unhighlight(feature);

        return new Leaflet.D3Layer({
            map: currentMap,
            scaleRange: [5, 20],
            expandView: 0.3,
            filter: {
                location: true
            },
            showAll: true,
            autofocus: false,
            uniqueField: 'Id',
            voronoi: true,
            // fastMode: true
            mouseover: onMouseover,
            mouseout: onMouseout,
            done: onComplete,
            click: onClick,
            success: onSuccess,
            symbology: {
                type: 'choropleth',
                theme: ColorBrewer.Paired[12],
                scale: 'nomenal',
                style: {
                    // highlight: true
                    lineJoin: 'round',
                    color: ColorFlatUI.wet_asphalt[1][0],
                    fillColor: 'transparent',
                    fillOpacity: 0.5,
                    opacity: 1,
                    weight: 1.2
                }
            }
        });
    }
}

export default VoronoiLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/VoronoiLayer.js